<template>
  <EventDataFormGroup name="Description">
    <template #input>
      <div id="description" ref="quill"></div>
    </template>
    <template #note>Descriptions allow you to elaborate on the event and provide any additional details you'd like</template>
  </EventDataFormGroup>
</template>

<script>
import Quill from 'quill'
import EventDataFormGroup from '../components/EventDataFormGroup'

export default {
  components: {
    EventDataFormGroup: EventDataFormGroup
  },
  props: {
    text: {
      type: String,
      default: () => ''
    },
    html: {
      type: String,
      default: () => ''
    },
    wasValidated: {
      type: Boolean,
      required: true
    },
    value: {}
  },
  data () {
    return {
      quill: null,
      quillToolbar: null
    }
  },
  methods: {
    initQuill () {
      this.quill = new Quill(this.$refs.quill, {
        theme: 'snow'
      })

      if (this.html) {
        this.quill.root.innerHTML = this.html
      } else if (this.text) {
        this.quill.root.innerText = this.text
      }

      this.quill.on('text-change', () => {
        this.$emit('text', this.textDescription())
        this.$emit('html', this.htmlDescription())
        this.checkValidity()
      })

      this.quillToolbar = window.$('.ql-toolbar')
    },
    textDescription () {
      return this.quill.root.innerText
    },
    htmlDescription () {
      return this.quill.root.innerHTML
    },
    checkValidity () {
      if (!this.wasValidated) return

      const isValid = this.textDescription().trim().length > 0
      if (isValid) {
        this.$refs.quill.classList.add('valid')
        this.$refs.quill.classList.remove('invalid')
        this.quillToolbar.css('border-color', '#28a745')
      } else {
        this.$refs.quill.classList.add('invalid')
        this.$refs.quill.classList.remove('valid')
        this.quillToolbar.css('border-color', '#dc3545')
      }
    }
  },
  watch: {
    wasValidated () {
      this.checkValidity()
    }
  },
  mounted () {
    this.initQuill()
  }
}
</script>

<style scoped>
@import "../assets/vendor/quill/quill.snow.css";

#description {
  height: 175px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.invalid {
  border-color: #dc3545;
}

.valid {
  border-color: #28a745;
}
</style>
